import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n, t } = useTranslation();

  const changeLanguage = (lng) => {
    // 言語を変更してページをリフレッシュ
    i18n.changeLanguage(lng).then(() => {
      // 言語変更後にページをリロード（APIから新しい言語のデータを取得）
      window.location.reload();
    });
  };

  const languages = [
    { code: 'ja', name: t('language.japanese'), flag: '🇯🇵' },
    { code: 'en', name: t('language.english'), flag: '🇺🇸' },
  ];

  const currentLang = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <div className="relative group">
      <button className="flex items-center gap-2 px-3 py-2 rounded-lg bg-white/50 border border-amber-500/30 hover:border-amber-500/50 transition-all">
        <Globe className="w-4 h-4 text-amber-500" />
        <span className="text-sm text-gray-900">{currentLang.flag} {currentLang.name}</span>
        <svg className="w-4 h-4 text-amber-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      <div className="absolute right-0 mt-2 w-48 rounded-lg bg-white border border-amber-500/30 shadow-xl opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-50">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => changeLanguage(lang.code)}
            className={`w-full flex items-center gap-3 px-4 py-3 hover:bg-amber-500/10 transition-colors ${
              i18n.language === lang.code ? 'bg-amber-500/20 text-amber-500' : 'text-gray-900'
            }`}
          >
            <span className="text-xl">{lang.flag}</span>
            <span className="text-sm">{lang.name}</span>
            {i18n.language === lang.code && (
              <svg className="w-4 h-4 ml-auto text-amber-500" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
              </svg>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageSwitcher;
